<template>
  <base-header class="pb-6">
    <b-row align-v="center" class="py-4">
      <b-col cols="12">
        <!-- Title Section -->
        <div class="mb-4">
          <h6 class="h2 text-white mb-0">Beacon Monitoring</h6>
          <p class="text-white-50 mb-0">Real-time patient visit tracking</p>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-n4">
      <b-col class="text-right">
        <div class="real-time-clock">
          <i class="far fa-clock mr-2"></i>
          <span class="d-none d-lg-inline ml-1">{{ currentTime }}</span>
        </div>
      </b-col>
    </b-row>
  </base-header>
</template>

<script>
export default {
  name: 'BeaconHeader',
  props: {
    currentTime: {
      type: String,
      default: 'Loading...'
    }
  }
}
</script>

<style scoped>
.real-time-clock {
  color: white;
  font-size: 0.9rem;
}
</style>